<div class="flex flex-col gap-4">
  <elcia-label [label]="'direct-debit.title' | translate"/>

  <div class="flex gap-4">
    <div class="w-1/4">
      <elcia-text-input [control]="control().controls.iban" [label]="'direct-debit.iban' | translate"/>
    </div>
    <div class="w-1/4">
      <elcia-text-input [control]="control().controls.bic" [label]="'direct-debit.bic' | translate"/>
    </div>
    <div class="w-1/4">
      <elcia-text-input [control]="control().controls.reference"
                        [label]="'direct-debit.reference' | translate"/>
    </div>
    <div class="w-1/4">
      <elcia-date-picker [control]="control().controls.signedAt"
                         [label]="'direct-debit.signed-at' | translate"/>
    </div>
  </div>

</div>
